export default __webpack_public_path__ + "static/media/melancia.b6ccfddc.jpg";